import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/images/minicity_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-77316024"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appContainer" }
const _hoisted_2 = {
  key: 0,
  id: "nav",
  class: "pt-4 pb-4 is-flex is-flex-direction-row"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Minicity Logo",
  width: "125",
  class: "logo",
  src: _imports_0
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "ml-4"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex-grow-1" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "ctaButton loginButton" }, "Sign In", -1))
const _hoisted_7 = { class: "pageWrapper" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "is-flex-grow-1" }, null, -1))
const _hoisted_9 = {
  key: 1,
  id: "footer",
  class: "pt-2 pb-2"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-2 pr-2" }, "© Mini City, Inc.", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" | ")
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-2 pr-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.minicityatl.com/privacypolicy",
    target: "_blank"
  }, "Privacy Policy")
], -1))
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]

import { onMounted } from "vue";
import { endSession, sessionState, chromeless } from "./core/session";
import { loadConfig, STATIC_CONFIG, Environment } from "./core/config";
import { displayedModalOffer, displayedModalContext, hideModalOffer, restoreModalOfferFromQueryParams } from '@/features/partnerOffers/state';

import OfferModal from '@/features/partnerOffers/OfferModal.vue';
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppPageFrame',
  props: {
    showHeader: { type: Boolean },
    login: null
  },
  setup(__props: any) {

const props = __props as {
  showHeader?: boolean,
  login?: 'require'|'disallow'
}



const router = useRouter();
const route = useRoute();

onMounted(async () => {
  await router.isReady();

  if (!sessionState.session && !route.query.sessionId) {
    const isSessionAvailableToResume = Boolean(localStorage["session"]);
    const shouldLogin = props.login == 'require' || (props.login != 'disallow' && isSessionAvailableToResume);
  
    if (shouldLogin) {
      router.push(`/login?forwardTo=${encodeURIComponent(document.location.pathname + document.location.search)}`);
      return;
    }
  }

  loadConfig();

  restoreModalOfferFromQueryParams();
});

const logout = () => {
  endSession();
  router.push("/login");
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.showHeader && !_unref(chromeless))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          (_unref(STATIC_CONFIG).ENV != _unref(Environment).PROD)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(STATIC_CONFIG).ENV), 1))
            : _createCommentVNode("", true),
          _hoisted_5,
          (_unref(sessionState).session)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "ctaButton loginButton",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (logout()))
              }, "Sign Out"))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: "/login"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: _normalizeClass(["contentWrapper", {'pt-5': !_unref(chromeless)}])
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ]),
    _hoisted_8,
    (!_unref(chromeless))
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_13))
      : _createCommentVNode("", true),
    (_unref(displayedModalOffer))
      ? (_openBlock(), _createBlock(OfferModal, {
          key: 2,
          offer: _unref(displayedModalOffer),
          context: _unref(displayedModalContext)!,
          onClosed: _cache[1] || (_cache[1] = ($event: any) => (_unref(hideModalOffer)())),
          style: {"z-index":"999"}
        }, null, 8, ["offer", "context"]))
      : _createCommentVNode("", true)
  ]))
}
}

})